// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/row","rootFixed":"row-m__rootFixed__3ejCY"};